import axios from 'axios';
import { resolveAuthHeaderValue } from '@/utils/authToken';
import { apiUrl } from '@/utils/appConfig';

const client = axios.create({ baseURL: apiUrl() });

client.interceptors.request.use(config => {
  const authHeaderValue = resolveAuthHeaderValue();
  if (!authHeaderValue) return config;
  const nextConfig = { ...config };
  if (!nextConfig.headers) nextConfig.headers = {};
  nextConfig.headers.Authorization = authHeaderValue;
  return nextConfig;
});

export async function listEnabledChannels({ category } = {}) {
  const params = { disabled: false };
  if (category) params.category = category;
  const { data } = await client.get('/api/rss-channels', { params });
  return Array.isArray(data) ? data : [];
}

export async function listCategories() {
  const { data } = await client.get('/api/rss-channels/categories');
  return Array.isArray(data) ? data : [];
}
